const generalSearch = () => {
    if (document.querySelector('.ume-intra-search-bar')) {
        const doSearch = (ev) => {
            if (!(ev.target.closest('.ume-intra-search-trigger:not(.ume-intra-glossary-search-trigger)') || (ev.target.classList.contains('ume-intra-search-trigger') && !ev.target.classList.contains('ume-intra-glossary-search-trigger')))) {
                return;
            }
            const button = ev.target.closest('.ume-intra-search-trigger');
            const holder = button.parentNode;
            const searchInput = holder.querySelector('.ume-intra-search-input');
            const searchQuery = searchInput.value;

            const params = new URLSearchParams({
                s: searchQuery
            })


            const target = window.location.origin + '/?' + params.toString();
            window.location.href = target;
        }
        document.addEventListener('click', ev => {
            doSearch(ev)
        });
        document.addEventListener('keypress', ev => {
            if (ev.key === 'Enter') {
                if (ev.target !== null && ev.target.classList.contains('ume-intra-search-input') && !ev.target.classList.contains('.ume-intra-glossary-search-input')) {
                    const holder = ev.target.parentNode;
                    const button = holder.querySelector('.ume-intra-search-trigger');
                    button.click()
                } else return;
            }else return;


        })

    }
}
export default generalSearch;